import { render, staticRenderFns } from "./InputPage.vue?vue&type=template&id=d7907386&scoped=true"
import script from "./InputPage.vue?vue&type=script&lang=js"
export * from "./InputPage.vue?vue&type=script&lang=js"
import style0 from "./InputPage.vue?vue&type=style&index=0&id=d7907386&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7907386",
  null
  
)

export default component.exports